import styled, { keyframes } from 'styled-components';
import centerPoint from '../assets/images/loader.svg';
const loaderAnimation = (translateWidth, id, backgroundColor, lastColor) => keyframes `
from {
  transform-origin: center center;
  transform: translateX(0) rotate(calc(${id * 45}deg));
  background: radial-gradient(${backgroundColor} 20%, transparent 20%);
}
35% {
  transform-origin: left center;
  transform: translateX(${translateWidth}) rotate(calc(${id * 45}deg)) rotate(360deg);
  background: radial-gradient(${backgroundColor} 20%, transparent 20%);
}
65% {
  transform-origin: left center;
  transform: translateX(${translateWidth}) rotate(calc(${id * 45}deg)) rotate(540deg);
  background: radial-gradient(${backgroundColor} 20%, transparent 20%);
}
88% {
  transform-origin: center center;
  transform: translateX(0) rotate(calc(${id * 45}deg)) rotate(720deg);
  background: radial-gradient(${lastColor} 20%, transparent 20%);
}
100% {
  transform-origin: center center;
  transform: translateX(0) rotate(calc(${id * 45}deg)) rotate(720deg);
  background: radial-gradient(${lastColor} 20%, transparent 20%);
}
`;
export const LoaderPointStyled = styled.span `
  position: absolute;
  width: 100%;
  height: 100%;
  mask-image: url(${centerPoint});
  mask-repeat: no-repeat;
  mask-position: center;
  left: 0%;
  top: 0%;
  mask-size: ${(props) => props.pointRadio || `2px`};

  animation: ${(props) => {
    const backgroundColor = () => {
        if (props.color)
            return props.color;
        switch (props.pointId) {
            case 8:
            case 1:
                return props.theme.colors.blue100;
            case 2:
                return props.theme.colors.blue200;
            case 3:
            case 4:
                return props.theme.colors.blue300;
            case 5:
            case 6:
                return props.theme.colors.blue400;
            default:
                return props.theme.colors.blue500;
        }
    };
    return loaderAnimation(`${+props.size / 2}px`, props.pointId, backgroundColor(), props.color || props.theme.colors.blue500);
}}
    1.7s ease-in-out infinite;
  animation-timing-function: linear;
`;
export const LoaderStyled = styled.div `
  max-width: ${(props) => `${props.size}px`};
  max-height: ${(props) => `${props.size}px`};
  min-width: ${(props) => `${props.size}px`};
  min-height: ${(props) => `${props.size}px`};
  display: flex;
  justify-content: center;
  align-items: center;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  position: relative;
`;
export const LoaderFrameStyled = styled.span `
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  transform-origin: 0px 0px;
  background-repeat: no-repeat;
  background-position: center;
`;
//# sourceMappingURL=styled.js.map